module.exports = __webpack_public_path__ + "img/3.57726d4a.jpg";